import { gql } from "@apollo/client";

export const GET_STAFF_BY_URL = gql`
  query GetStaffByUrl($staffUrl: String!, $businessUrl: String!) {
    staffByUrl(staffUrl: $staffUrl, businessUrl: $businessUrl) {
      status
      id
      url
      showGoogleEvents
      image {
        id
        url
        staffId
      }
      subscription {
        id
        planId
      }
      workingHourGroups {
        id
        title
        def
        custom
        isForBusiness
        timeZone {
          id
          timezone
        }
        workingHours {
          id
          groupId
          day
          onJob
          startTime
          endTime
          parentId
        }
        workingHourOverrideGroups {
          id
          groupId
          startDate
          endDate
          title
          workingHourOverrides {
            id
            whOverrideGroupId
            startTime
            endTime
          }
        }
      }
      user {
        id
        email
        username
        desc
        timeZone {
          id
          timezone
        }
      }
      role {
        id
        name
        permissions
      }
    }
  }
`; 

